import axios from "axios";
import { baseUrl, baseUrl2 } from '../../config/clientsConfig'

const loginService = {

  loginUser: (loginData) => {
    return axios.post(`${baseUrl2}/users/login`, loginData);
  },

    resetPassword: (resetData) => {
    return axios.post(`${baseUrl}/user/reset`, resetData);
  }
};

  export default loginService;